export default __webpack_public_path__ + "static/sfls-562c5c05297e3a6b67fb95d8b29d758b.png";